"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnonymousIdentity = void 0;
const types_1 = require("../types");
const cose_1 = require("../../message/cose");
const address_1 = require("../address");
class AnonymousIdentity extends types_1.Identity {
    async sign() {
        return cose_1.EMPTY;
    }
    async verify() {
        return false;
    }
    async getAddress() {
        return address_1.Address.anonymous();
    }
    toJSON() {
        return { dataType: this.constructor.dataType };
    }
}
exports.AnonymousIdentity = AnonymousIdentity;
AnonymousIdentity.dataType = 'anonymous';
